import { lazy } from 'react';
import { RouteItem } from '@/utils/generateRouter';

const routes: RouteItem[] = [
  {
    index: true,
    redirect: 'pc'
  },
  {
    path: 'pc',
    name: '电脑端注册',
    // icon: <SvgRender name="organ" />,
    component: lazy(() => import('@/pages/PcClient'))
  },
  {
    path: 'mobile',
    name: '手机端注册',
    // icon: <SvgRender name="organ" />,
    component: lazy(() => import('@/pages/MobileClient'))
  },
  {
    path: 'product-publish-process',
    name: '产品上架流程',
    // icon: <SvgRender name="organ" />,
    component: lazy(() => import('@/pages/ProductPublishProcess'))
  },
  {
    path: 'organ-process',
    name: '新建团体流程',
    // icon: <SvgRender name="organ" />,
    component: lazy(() => import('@/pages/OrganProcess'))
  }
];

export default routes;
